import { ROUTE_PATH, OperationType } from "common/constants/sm-constants";
import { WidgetModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class InternshipListGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Internship',
            ROUTE_PATH.internship,
            ROUTE_PATH.addUser,
            false,
            true,
            8,
            false,
            false,
            ['orgname'],
            false,
            [],
            { isDownloadExcel: true, excelFileName: 'Result Reports_' + new Date().toLocaleDateString() + '.xlsx', btnLabel: 'Download All', headers: [{ key: 'StudentName', value: 'orgname' }, { key: 'CollegeName', value: 'name_of_college' }, { key: 'Branch', value: 'branch_name' }, { key: 'Sem1', value: 'semester1' }, { key: 'Sem2', value: 'semester2' }, { key: 'Sem3', value: 'semester3' }, { key: 'Sem4', value: 'semester4' }, { key: 'Sem5', value: 'semester5' }, { key: 'Sem6', value: 'semester6' }, { key: 'Sem7', value: 'semester7' }, { key: 'Sem8', value: 'semester8' }, { key: 'TotalPercent', value: 'scoreTotal' }, { key: 'Status', value: 'statusType' }] },
            false,
            null,
            false,
            false,
            true,
            null,
            { evalKey: 'wantToDelete', evalParam: [1], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            [],
            false,
            {
                isExtraActions: true,
                btnLabel: '',
                selectOptions: [
                    { key: 'Student List', value: 'student' },
                    { key: 'Internship List', value: 'internship' },],
                selectedValue: 'internship',
            },
            { isCheckboxEmit: true, emitKey: 'student_id', checkedKey: '', valueKey: '' },
            { isDownload: false, key: '', valueKey: '' },
            { isTabStatus: false, label: '', isChecked: false },
            true,
            true,
            {
              isPrimary: false,
              isDanger: true,
            },
            

        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const internshipTitle = new Headers('Internship Title', 'internshipTitle', false, false, 'text');
        const companyName = new Headers('Internship Company', 'companyName', false, false, 'text');
        const locName = new Headers('Location', 'locName', false, false, 'text');
        const internshipStartDate = new Headers('Start Date', 'internshipStartDate', false, false, 'text');
        const internshipEndDate = new Headers('End Date', 'internshipEndDate', false, false, 'text');
        const mentorName = new Headers('Mentor Name', 'mentorName', false, false, 'text');
        const StudentCount = new Headers('Student Count', 'StudentCount', false, false, 'text', '0', {
            isColumnNavigation: true,
            navigationUrl: ROUTE_PATH.intershipDetails,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: new WidgetModel()
        });

        headers.push(internshipTitle);
        headers.push(companyName);
        headers.push(locName);
        headers.push(internshipStartDate);
        headers.push(internshipEndDate);
        headers.push(mentorName);
        headers.push(StudentCount);
        return headers;
    }
}